export default "__VITE_ASSET__DfPFrh9O__"